import jwt from 'jsonwebtoken';
import client from '../feathers';
import logSentry from './logSentry'

export const checkExpiredToken = (token) => {
  // console.log("    checkExpiredToken", token)
  let value;
  let returnValue = false;
  
  if (!token) { returnValue = true };

  if (!returnValue) {
    value = jwt.decode(token);
    if (!value) { returnValue = true }
  }

  if (!returnValue) {
    const { exp } = value;
    // console.log("    checkExpiredToken exp", exp)

    if (Date.now() >= exp * 1000) { returnValue = true };
  }

  if (returnValue) {
    // delete token if expired
    // console.log("    checkExpiredToken: delete expired token")
    let walletInfo = window.walletApi._getWalletInfo();
    delete walletInfo.token;
    window.walletApi._storeWalletInfo(walletInfo);
  }

  return returnValue;
};

export const isTokenValid = () => {
  const item = window.localStorage.getItem('tmining_wallet');
  // console.log(">>> item", item)
  if (!item) return false;

  try {
    const obj = JSON.parse(item);
    if (!obj.token) return false;

    return !checkExpiredToken(obj.token);
  } catch (e) {
    logSentry(e);
    return false;
  }
};

export const getAccessToken = async (url) => {
  const token = await client.authentication().getAccessToken();
  // console.log("getAccessToken, token", url, token)

  // we always need the token from localStorage in case we're going to 2FA
  if (!token || url.includes("/two-factor/auth/")) {
    let item = window.localStorage.getItem("tmining_wallet");
    if (!item) return null;
    item = JSON.parse(item);
    // console.log("getAccessToken, item.token", item.token)
    return item.token;
  } else {
    return token;
  }
}


